import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryGoodsAttributeValues(goodsId,
  {
    page, size, direction, sort,
  }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-attribute-values`,
    method: 'get',
    params: {
      goodsId,
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryGoodsAttributeValue(goodsAttributeValueId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-attribute-values/${goodsAttributeValueId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addGoodsAttributeValue(
  {
    name,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-attribute-values`,
    method: 'post',
    data: {
      name,
    },
  });
}

/**
 * 更新
 * @param goodsAttributeValueId
 * @param  isActive
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateGoodsAttributeValue(goodsAttributeValueId, {
  name,
  isActive,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-attribute-values/${goodsAttributeValueId}`,
    method: 'patch',
    data: {
      name,
      isActive,
    },
  });
}

/**
 * 删除
 * @param goodsAttributeValueId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteGoodsAttributeValue(goodsAttributeValueId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-attribute-values/${goodsAttributeValueId}`,
    method: 'delete',
  });
}

export default {};
